(() => {
  'use strict';

  const cleanZeroWishlistCount = () => {
    document.querySelectorAll('.m-header__mobile-right .mobile-wishlist *').forEach((element) => {
      const text = (element.textContent || '').trim();
      const className = typeof element.className === 'string' ? element.className.toLowerCase() : '';
      const looksLikeCounter = /count|badge|number|quantity/.test(className);

      if (looksLikeCounter && text === '0') {
        element.classList.add('ra-zero-count-hidden');
        element.setAttribute('aria-hidden', 'true');
      } else if (looksLikeCounter && text !== '0') {
        element.classList.remove('ra-zero-count-hidden');
        element.removeAttribute('aria-hidden');
      }
    });
  };

  const run = () => window.requestAnimationFrame(cleanZeroWishlistCount);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  new MutationObserver(run).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();